import React, { Component } from 'react'
import Axios from 'axios';

class PostList extends Component {

    state = { 
        posts: []
    };

    componentDidMount() {
        const { user } = this.props;

        // Axios.get(`https://jsonplaceholder.typicode.com/posts?userId=${user.id}`)
        // .then((result) => {
        //     console.log(result);

        //     this.setState({
        //         posts: result.data,
        //     });
        // });
        this.getUserPostsList(user.id);
    }

    //same code in two lifecycle thats y combining into one method function
    getUserPostsList = (id) =>{
        Axios.get(`https://jsonplaceholder.typicode.com/posts?userId=${id}`)
        .then((result) => {
            console.log(result);

            this.setState({
                posts: result.data.slice(0,4),
            });
        });
    }


    // if we change the state/props this lifecycle will run
    componentDidUpdate(prevProps, prevState) {
        // console.log("prevProps", prevProps, "prevState", prevState);
        // console.log("props", this.props, "State", this.state);
        console.log("Old User", prevProps.user.id);
        console.log("New User", this.props.user.id);

        if(prevProps.user.id !== this.props.user.id) {
            //call api here
        this.getUserPostsList(this.props.user.id);
        }
    }


  render() {
      const { posts } = this.state;

    return (
    <>
        { posts.map((post) => {
            return (
            <div className="ui link card piled segment" key={post.id}>
            <div className="content">
            <div className="header">{post.title}</div>
                <div className="meta">
                <span className="category">Human Resources</span>
                </div>
                <div className="description">
                <p>{post.body}</p>
                </div>
            </div>
            <div className="extra content">
                <div className="right floated author">
                <i className="thumbtack icon" />
                {post.id}
                </div>
                </div>
            </div>
            )
        })}
    </>
    )
  }
}

export default PostList;
